import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46d96c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logs-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_Logs = _resolveComponent("Logs")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_card, {
    class: "logs-bottom-card shadow-2 bg-white",
    square: "",
    style: _normalizeStyle({ height: _ctx.height + 'px' })
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "drag-handle",
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args)), ["prevent"])),
        onTouchstart: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args)), ["prevent"]))
      }, null, 32),
      _createVNode(_component_q_bar, {
        dense: "",
        class: "logs-bar"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.t('logs.title')), 1),
          _createVNode(_component_q_space),
          _createVNode(_component_q_btn, {
            dense: "",
            flat: "",
            icon: "close",
            onClick: _ctx.closeDialog
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "logs-scroll q-pa-none" }, {
        default: _withCtx(() => [
          _createVNode(_component_Logs, {
            key: _ctx.logsKey,
            class: "full-height"
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"])), [
    [_vShow, _ctx.modelValue]
  ])
}